import { Dialog, DialogTitle, IconButton } from "@mui/material";
import React from "react";
import useAppGlobal from "../../context/useAppGlobal";
import { Close } from "@mui/icons-material";

export default function DialogComp() {
  const { dialogContent, isOpen, closeDialog, size = "sm", title, isDisableBackdropClick } = useAppGlobal();
  return (
    <Dialog
      fullWidth
      maxWidth={size}
      // scroll="paper"
      open={isOpen}
      onClose={isDisableBackdropClick ? () => {} : closeDialog}
      sx={{
        ".MuiPaper-root": {
          borderRadius: "10px !important",
          m: "0 auto",
          // ...(size === "xs" ? { maxWidth: "400px !important", width: "100%" } : {}),
        },
      }}
    >
      {typeof title === "string" ? (
        <DialogTitle
          fontWeight="bold"
          display="flex"
          justifyContent="space-between"
          sx={{ borderBottom: "1px solid var(--grey)", mb: "8px" }}
        >
          {title}
          <IconButton
            onClick={closeDialog}
            sx={{ width: "24px", height: "24px" }}
          >
            <Close sx={{ fontSize: "22px" }} />
          </IconButton>
        </DialogTitle>
      ) : (
        title
      )}
      {dialogContent}
    </Dialog>
  );
}
